import { YardType } from 'src/types';
import { getUrl } from 'src/utils';
import axios from '../axios';
import routes from '../routes';

const yards = {
  // Get all yards(respecting your tenant_id)
  getAllYards: (): Promise<Partial<YardType>[]> => axios.get(routes.YARDS),
  addYard: (yard: YardType) => axios.post(routes.YARDS, yard),
  getYard: ({ id }: { id: number }): Promise<Partial<YardType>[]> => axios.get(getUrl(routes.YARD, { id })),
  saveYard: (yard: YardType): Promise<Partial<YardType>[]> => axios.patch(getUrl(routes.YARD, { id: yard?.id }), { ...yard, id: undefined }),
  deleteYard: ({ id }: { id: number }): Promise<Partial<YardType>[]> => axios.delete(getUrl(routes.YARD, { id })),
};

export default yards;
